import { writable } from 'svelte/store';

function createEventBus() {
    const { subscribe, update } = writable([]);

    function emit(event, data) {
        update(events => {
            events.push({ event, data });
            return events;
        });
    }

    function listen(eventType, callback) {
        return subscribe(events => {
            events.forEach(({ event, data }) => {
                if (event === eventType) {
                    callback(data);
                }
            });
        });
    }

    return {
        emit,
        listen
    };
}

export const eventBus = createEventBus();
